import { ComponentPropsWithoutRef } from 'react'

import { cn } from '@/utils/tw-helpers'

interface Props extends ComponentPropsWithoutRef<'header'> {
  title: string
}

export const WebPageBanner = ({ title, className, ...rest }: Props): JSX.Element => {
  return (
    <header
      className={cn(
        'flex h-[54px] items-center justify-center bg-primary-75 md:h-[100px]',
        className
      )}
      {...rest}
    >
      <h2 className="text-xl font-bold text-white md:text-[32px]">{title}</h2>
    </header>
  )
}
